/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { getForteDecisionFlag, useForteDecisionFlag } from '@/features/forte/api/getForteDecision';
import { type QueryClient } from '@tanstack/react-query';

const DEFAULT_CONFIG = 'default_search';

export const getSearchServingConfigFromQueryClient = (queryClient: QueryClient) => {
  const maybeServingConfig = getForteDecisionFlag(queryClient, 'servingConfig');

  return maybeServingConfig || DEFAULT_CONFIG;
};

export const useSearchServingConfig = () => {
  const servingConfig = useForteDecisionFlag('servingConfig');

  return servingConfig || DEFAULT_CONFIG;
};
